import React from 'react';
import { Header, Region } from '../components';

const Home = () => {
  return (
    <>
      <Header>
        <Region />
      </Header>
    </>
  );
};

export default Home;
